module.exports = __webpack_public_path__ + "static/media/min-presentation.821b5e9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Experience/Alumni/min-presentation.jpg
// module id = 1090
// module chunks = 0